import axios from '@axios'
import { storePagination, sorting } from '@/mixins'

const getInitialState = () => ({
  ...storePagination.state(),
  filters: {
    status: null,
  },
  reconciliation: {
    id: null,
    checkingAccount: {
      id: null,
      name: null,
    },
    movementDate: null,
    percentCommissionTax: null,
    status: null,
  },
  summaryFields: {
    erpTotalValue: {},
    stripeTotalValue: {},
    stripeTotalCommission: {},
  },
  summaryAdjustmentFields: {
    stripeTotal: {},
    stripeTotalValue: {},
    stripeTotalCommission: {},
  },
  summaryRefundFields: {
    stripeTotal: {},
    stripeTotalValue: {},
    stripeTotalCommission: {},
  },
  summaryReservedFundFields: {
    stripeTotal: {},
    stripeTotalValue: {},
    stripeTotalCommission: {},
  },
  summaryTransferFields: {
    stripeTotal: {},
    stripeTotalValue: {},
    stripeTotalCommission: {},
  },
  reconciliationItems: [],
  reconciliationAdjustmentItems: [],
  reconciliationRefundItems: [],
  reconciliationReservedFundItems: [],
  reconciliationTransferItems: [],
})

export default {
  namespaced: true,
  state: getInitialState(),
  mutations: {
    ...storePagination.mutations,
    SET_RECONCILIATION(state, reconciliation) {
      state.reconciliation = reconciliation
    },
    SET_RECONCILIATION_ITEMS(state, items) {
      state.reconciliationItems = items
    },
    SET_SUMMARY_FIELDS(state, summaryFields) {
      state.summaryFields = summaryFields
    },
    SET_RECONCILIATION_ADJUSTMENT_ITEMS(state, items) {
      state.reconciliationAdjustmentItems = items
    },
    SET_SUMMARY_ADJUSTMENT_FIELDS(state, summaryFields) {
      state.summaryAdjustmentFields = summaryFields
    },
    SET_RECONCILIATION_REFUND_ITEMS(state, items) {
      state.reconciliationRefundItems = items
    },
    SET_SUMMARY_REFUND_FIELDS(state, summaryFields) {
      state.summaryRefundFields = summaryFields
    },
    SET_RECONCILIATION_RESERVEDFUND_ITEMS(state, items) {
      state.reconciliationReservedFundItems = items
    },
    SET_SUMMARY_RESERVEDFUND_FIELDS(state, summaryFields) {
      state.summaryReservedFundFields = summaryFields
    },
    SET_RECONCILIATION_TRANSFER_ITEMS(state, items) {
      state.reconciliationTransferItems = items
    },
    SET_SUMMARY_TRANSFER_FIELDS(state, summaryFields) {
      state.summaryTransferFields = summaryFields
    },
    SET_FILTERS(state, filters) {
      state.filters = filters
      state.filters = null
    },


    CLEAN_STATE(state) {
      const {
        reconciliation,
        reconciliationItems,
        reconciliationAdjustmentItems,
        reconciliationRefundItems,
        reconciliationReservedFundItems,
        reconciliationTransferItems,
        reconciliationFile,
        filters,
      } = getInitialState()
      state.reconciliation = reconciliation
      state.reconciliationItems = reconciliationItems
      state.reconciliationAdjustmentItems = reconciliationAdjustmentItems
      state.reconciliationRefundItems = reconciliationRefundItems
      state.reconciliationReservedFundItems = reconciliationReservedFundItems
      state.reconciliationTransferItems = reconciliationTransferItems
      state.reconciliationFile = reconciliationFile
      state.filters = filters
    },
  },
  actions: {
    ...storePagination.actions,
    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
    async fetchReconciliation({ commit }, id) {
      const { data } = await axios.get(`/api/financial/reconciliation/stripe/${id}`)
      commit('SET_RECONCILIATION', data)
    },
    async fetchReconciliationItems({ commit, state }, id) {
      const params = {
        sortBy: sorting.methods.getSorting(state),
        pageSize: state.paging.pageSize,
        pageIndex: state.paging.currentPage - 1,
      }
      const { data } = await axios.get(`/api/financial/reconciliation/stripe/${id}/items`, {
        params,
      })
      commit('SET_RECONCILIATION_ITEMS', data.results)
      commit('SET_SUMMARY_FIELDS', data.summaryFields)
      commit('SET_PAGING', {
        ...state.paging,
        rowCount: data.rowCount || 0,
        rowsInCurrentPage: data.rowsInCurrentPage || 0,
      })
    },
    async fetchReconciliationAdjustmentItems({ commit }, id) {
      const params = {
        pageSize: 0,
        pageIndex: 0,
      }
      const { data } = await axios.get(`/api/financial/reconciliation/stripe/${id}/adjustment-items`, {
        params,
      })
      commit('SET_RECONCILIATION_ADJUSTMENT_ITEMS', data.results)
      commit('SET_SUMMARY_ADJUSTMENT_FIELDS', data.summaryFields)
    },
    async fetchReconciliationRefundItems({ commit }, id) {
      const params = {
        pageSize: 0,
        pageIndex: 0,
      }
      const { data } = await axios.get(`/api/financial/reconciliation/stripe/${id}/refund-items`, {
        params,
      })
      commit('SET_RECONCILIATION_REFUND_ITEMS', data.results)
      commit('SET_SUMMARY_REFUND_FIELDS', data.summaryFields)
    },
    async fetchReconciliationReservedFundItems({ commit }, id) {
      const params = {
        pageSize: 0,
        pageIndex: 0,
      }
      const { data } = await axios.get(`/api/financial/reconciliation/stripe/${id}/reservedFund-items`, {
        params,
      })
      commit('SET_RECONCILIATION_RESERVEDFUND_ITEMS', data.results)
      commit('SET_SUMMARY_RESERVEDFUND_FIELDS', data.summaryFields)
    },
    async fetchReconciliationTransferItems({ commit }, id) {
      const params = {
        pageSize: 0,
        pageIndex: 0,
      }
      const { data } = await axios.get(`/api/financial/reconciliation/stripe/${id}/transfer-items`, {
        params,
      })
      commit('SET_RECONCILIATION_TRANSFER_ITEMS', data.results)
      commit('SET_SUMMARY_TRANSFER_FIELDS', data.summaryFields)
    },
    resetFilters({ commit }) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTERS', getInitialState().filters)
    },
  },
}
